const validateByType = (type, val) => {
  let status;
  switch (type) {
    case 'text':
      status = val !== '';
      break;
    case 'phone':
      status = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(val);
      break;
    case 'zipcode':
      status = new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/).test(val);
      break;
    case 'email':
      /* eslint-disable no-useless-escape */
      status = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(val);
      /* eslint-enable no-useless-escape */
      break;
    case 'password':
      // Minimum of 8 characters, including at least 1 letter, 1 number, and
      // 1 special character (!, @, #, $, ^, &, or *).
      status = new RegExp(/^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$^&*]).{8,}$/).test(val);
      break;
    case 'productcode':
      status = new RegExp(/^(\d{1,}$)/).test(val); /* eslint-disable-line no-useless-escape */
      break;
    case 'numberonly':
      status = new RegExp(/^(\d{1,}$)/).test(val); /* eslint-disable-line no-useless-escape */
    default:
      break;
  }
  return status;
};

// Format phone as xxx-xxx-xxxx
const formatPhone = (s) => {
  if (s !== null && s !== undefined && s !== '') {
    if (s.match(new RegExp(/\d/g) || []) !== null) {
      const arr = s.match(new RegExp(/\d/g) || []).join('');
      return `${arr.substring(0, 3)}-${arr.substring(3, 6)}-${arr.substring(6)}`;
    }
    return s;
  }
  return s;
};

const getValidateType = (field) => {
  const validateBy = field.getAttribute('validate');
  if (validateBy && validateBy.trim() !== '') {
    return validateBy;
  }
  // Legacy support for Episerver forms (do not contain validate="" attribute)
  if (field.classList.contains('u-validation__email')) {
    return 'email';
  } else if (field.classList.contains('u-validation__phone')) {
    return 'phone';
  } else if (field.classList.contains('u-validation__zip')) {
    return 'zipcode';
  } else if (field.classList.contains('u-validation__passwordMatch')) {
    return 'password';
  }
  return 'text';
};

const getFieldWrapper = (form, field) => {
  let fieldWrapper = field.closest('.Form__Element');
  if (!fieldWrapper) {
    fieldWrapper = form.querySelector(`[for="${field.id}"]`).parentNode;
  }
  return fieldWrapper;
};

const validate = (form) => {
  // Identify all fields with a validate attribute in form (will be on the label for the input/submit)
  const fieldList = form.querySelectorAll('[validate], [required]');
  const fieldErrorList = [];
  let isValid;
  let required;
  let isFormValid = true;
  [...fieldList].forEach((field) => {
    isValid = true;
    required = field.getAttribute('required') !== null;
    // If value is required, run against validation OR
    if (required) {
      isValid = validateByType(getValidateType(field), field.value);
    }
    // If value isn't required but value has been entered that requires validation, then run
    if (!required && field.value !== '' && getValidateType(field) !== 'text') {
      isValid = validateByType(getValidateType(field), field.value);
    }
    if (getValidateType(field) === 'password') {
      isValid = validatePasswordMatch(form);
    }
    const fieldWrapper = getFieldWrapper(form, field);
    if (!fieldWrapper) return;
    // If field type is radio or checkbox, confirm
    // field:checked w/in group
    if (field.type === 'radio' || field.type === 'checkbox') {
      isValid = fieldWrapper.querySelectorAll(':checked').length > 0;
    }
    // Mark form as invalid
    const fieldError = fieldWrapper.querySelector('.text-danger');
    if (!isValid) {
      isFormValid = isValid;
      fieldWrapper.classList.add('ValidationFail');
      if (fieldError) {
        fieldError.classList.add('field-validation-error');
        fieldError.classList.remove('field-validation-valid');
      }
      fieldErrorList.push(field);
    } else {
      fieldWrapper.classList.remove('ValidationFail');
      if (fieldError) {
        fieldError.classList.remove('field-validation-error');
        fieldError.classList.add('field-validation-valid');
      }
    }
  })
  // Add focus to first error, if form is invalid
  if (fieldErrorList.length > 0) {
    fieldErrorList[0].focus();
  }
  return isFormValid;
};

const validatePasswordMatch = (form) => {
  const passwordList = form.querySelectorAll('.u-validation__passwordMatch');
  if (passwordList.length < 2) return true; // No or only 1 password field, no matching, consider valid
  if (
    passwordList[0].value === passwordList[1].value &&
    validateByType('password', passwordList[0].value) &&
    validateByType('password', passwordList[1].value)
  ) {
    return true;
  }
  return false;
};

const removeAllErrors = (form) => {
  const fieldList = form.querySelectorAll('[validate]');
  [...fieldList].forEach((field) => {
    const fieldWrapper = getFieldWrapper(form, field);
    if (fieldWrapper) {
      fieldWrapper.classList.remove('ValidationFail');
    }
  });
};

const addRequiredAttrs = (form) => {
  const inputList = form.querySelectorAll('.o-form__input');
  [...inputList].forEach((input) => {
    input.setAttribute('required', 'required');
  });
};

const removeRequiredAttrs = (form) => {
  const inputList = form.querySelectorAll('.o-form__input');
  [...inputList].forEach((input) => {
    input.removeAttribute('required');
  });
};

const clearInputValues = (form) => {
  const inputList = form.querySelectorAll('.o-form__input');
  [...inputList].forEach((input) => {
    input.value = '';
  });
};

const positionWindowAtFormElement = (options) => {
  const {
    element,
    offset,
  } = options;
  const elementTop = element ? element.offsetTop : 0;
  const offsetTop = offset ? offset : 0;
  window.scrollTo({
    top: elementTop + offsetTop,
    behavior: 'smooth',
  });
};

const disableFormSubmit = (form) => {
  if (!form) return;
  const submitBtn = form.querySelector('[type=submit]');
  if (!submitBtn) return;
  submitBtn.disabled = true;
  submitBtn.classList.add('updating');
};

const enableFormSubmit = (form) => {
  if (!form) return;
  const submitBtn = form.querySelector('[type=submit]');
  if (!submitBtn) return;
  submitBtn.disabled = false;
  submitBtn.classList.remove('updating');
};

const convertInputTypeToPassword = (form) => {
  const passwordInputList = form.querySelectorAll('.o-form__input--password');
  passwordInputList.forEach((item) => {
    item.setAttribute('type', 'password');
  });
};

export {
  addRequiredAttrs,
  clearInputValues,
  convertInputTypeToPassword,
  disableFormSubmit,
  enableFormSubmit,
  formatPhone,
  positionWindowAtFormElement,
  removeAllErrors,
  removeRequiredAttrs,
  validate,
  validateByType,
  validatePasswordMatch,
};
